export default "__VITE_ASSET__BhvwB30Z__"